import React from 'react';
import { connect } from 'react-redux';

import { setAttachedGoods as setAG } from '../../Actions/app';
import { changeCurrentOrder } from '../../Actions/changeCurrentOrder';
import checkGoodInOrder from '../../utilities/checkGoodInOrder';
import getCountGoodInOrder from '../../utilities/getCountGoodInOrder';
import s from './Good.module.scss';

const AttachedGoods = props => {
  const {
    t,
    product,
    goods,
    attachedGoods,
    orderGoods,
    setAttachedGoods_,
    changeOrder
  } = props;

  // Дополнительные товары для ECG Dongle Full shopGood = 2
  const attach_2_7 = 7;
  const priceAttach_2_7 = goods[attach_2_7]?.cost;
  const attach_2_8 = 8;
  const priceAttach_2_8 = goods[attach_2_8]?.cost;

  if (t.language !== 'ru') return null;

  const checkAttachedlGoods = (goodId, attId) => {
    if (getCountGoodInOrder(orderGoods, goodId)) {
      return getCountGoodInOrder(orderGoods, attId);
    }
    return attachedGoods[goodId] && attachedGoods[goodId][attId];
  };

  const setAttachedlGoods = (e, goodId, attId) => {
    const count = e.target.checked ? 1 : 0;
    setAttachedGoods_({
      [goodId]: { ...attachedGoods[goodId], [attId]: count }
    });
    // если goodId уже в корзине, то добавить или удалить из корзины
    if (checkGoodInOrder(orderGoods, goodId)) {
      if (checkGoodInOrder(orderGoods, attId)) {
        const changeGoods = orderGoods.map(i => {
          if (+i.shopGood === +attId) {
            return { ...i, count };
          }
          return i;
        });
        changeOrder({ goods: changeGoods }, 0, 1, false);
      } else {
        changeOrder(
          { goods: [...orderGoods, { shopGood: attId, count }] },
          0,
          1,
          false
        );
      }
    }
  };

  return (
    <div className="attached-goods">
      {+product.shopGood === 1 ? (
        <p>
          <label className="stylized-checkbox">
            <input type="checkbox" checked disabled name="" value="" />
            <span className="pseudocheckbox">
              4 многоразовых электрода{' '}
              <span className="highlighted-information">бесплатно</span> в
              комплекте
            </span>
          </label>
        </p>
      ) : null}
      {+product.shopGood === 2 ? (
        <div>
          <p>
            <label className="stylized-checkbox">
              <input
                type="checkbox"
                checked={checkAttachedlGoods(2, attach_2_7)}
                disabled=""
                name=""
                value=""
                onChange={e => setAttachedlGoods(e, 2, attach_2_7)}
              />
              <span className="pseudocheckbox">
                +{priceAttach_2_7} р. за электроды для ЭКГ многоразовые грудные,
                с винтом/зажимом (6 шт.)&nbsp;
                <span className={s.highlightedInteraction}>
                  {checkAttachedlGoods(2, attach_2_7) ? 'убрать' : 'добавить'}
                </span>
              </span>
            </label>
          </p>
          <p>
            <label className="stylized-checkbox">
              <input
                type="checkbox"
                checked={checkAttachedlGoods(2, attach_2_8)}
                disabled=""
                name=""
                value=""
                onChange={e => setAttachedlGoods(e, 2, attach_2_8)}
              />
              <span className="pseudocheckbox">
                +{priceAttach_2_8} р. за электроды для ЭКГ многоразовые для
                взрослых на конечности (4 шт.)&nbsp;
                <span className={s.highlightedInteraction}>
                  {checkAttachedlGoods(2, attach_2_8) ? 'убрать' : 'добавить'}
                </span>
              </span>
            </label>
          </p>
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = state => ({
  goods: state.goods,
  orderGoods: state.currentOrder.order && state.currentOrder.order.goods,
  attachedGoods: state.app.attachedGoods,
  t: state.translation
});

const mapDispatchToProps = {
  setAttachedGoods_: setAG,
  changeOrder: changeCurrentOrder
};

export default connect(mapStateToProps, mapDispatchToProps)(AttachedGoods);